import { Component, ViewChild, TemplateRef, Output, EventEmitter, Input } from '@angular/core';
import { ConfirmLocationModalComponent } from '../confirm-location-modal/confirm-location-modal.component';
import { LocationSelection, validLocation } from 'src/app/services/location-lookup.service';

@Component({
  selector: 'app-search-location',
  templateUrl: './search-location-modal.component.html',
  styleUrls: ['./search-location-modal.component.scss'],
})
export class SearchLocationModalComponent {
  @Input() emitCloseEvent = true;
  @Input() addressOnboarding = '';
  @Input() cityOnboarding = '';
  @Input() businessDetaillat = 0;
  @Input() businessDetaillng = 0;
  @ViewChild('searchLocationModal') searchLocationTemplate!: TemplateRef<any>;
  @ViewChild('confirmLocationModal') confirmLocationComponent!: ConfirmLocationModalComponent;
  @Output() openProfileModal = new EventEmitter<void>();
  @Output() FillAddressDetails = new EventEmitter<LocationSelection>();

  handleClose(modal: any): void {
    modal.dismiss('Cross click');
    if (this.emitCloseEvent) this.openProfileModal.emit();
  }

  confirmSelection(location: LocationSelection | null, modal: any): void {
    if (!validLocation(location)) return;
    modal.close();
    this.confirmLocationComponent.open(location);
  }

  confirmed(location: LocationSelection): void {
    this.FillAddressDetails.emit(location);
    if (this.emitCloseEvent) this.openProfileModal.emit();
  }
}
